import { Tooltip, TooltipFocusableTrigger } from "@zapier/design-system";
import { Icon, IconName } from "@zapier/zinnia-icons";
import styles from "./MenuItemLabel.module.css";

export const MenuItemLabel = ({
  icon = "alertInfo",
  label,
  tooltipText,
}: {
  icon?: IconName;
  label: string;
  tooltipText?: string;
}) => {
  return (
    <div className={styles.root}>
      {label}
      <Tooltip content={tooltipText || ""} allowMultiline>
        <TooltipFocusableTrigger>
          <Icon name={icon as IconName} />
        </TooltipFocusableTrigger>
      </Tooltip>
    </div>
  );
};
